<template>
  <div
    class="effect-setting setting-popup"
    v-if='boxData.judgeBox'
    :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex}"
    @mousedown.stop.prevent
  >
    <div
      class="setting-popup__drag-area"
      @mousedown="moveStart($event, true)"
      @mousemove="moveArea($event)"
      @mouseup="saveMoveState($event)" :style="{'cursor': 'move'}"
    >
      样式
    </div>

    <div class="settting-popup__content">
      <ul class="items">
        <li class="item">
          <div class="item__title">透明度</div>
          <div class="item__main">
            <slider
              :runway-size="110"
              :number-unit="'%'"
              @updateValue="onTransparentUpdated"
              ref="transparentSlider"
            ></slider>
          </div>
        </li>

        <li class="item">
          <div class="item__title">样式</div>
          <div class="item__main">
            <span
              v-for="(v, i) in options"
              :key="i"
              class="item__style" :class="{'is-selected': v.selected}"
              :style="v.style"
              @click="selectStyle(v)"
            >{{v.text}}</span>
          </div>
        </li>
      </ul>
    </div>

    <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
    <div class="setting-popup__mask" v-show="isShowMask" @click="closeNextPopup('color')"></div>
  </div>
</template>

<script>
import popup from '../../mixins/popup.vue'
import slider from '../../popups/content/slider.vue'
import base from './base'

export default {
  mixins: [popup, base],
  components: {
    slider
  },
  data () {
    return {
      popupType: 'textStyleSetting',
      options: [
        {
          text: 'B',
          name: 'fontWeight',
          value: 'bold',
          anti: 'normal',
          selected: false,
          style: {
            'font-weight': 800,
          }
        }, {
          text: 'I',
          name: 'fontStyle',
          value: 'italic',
          anti: 'normal',
          selected: false,
          style: {
            'font-style': 'italic',
          }
        }, {
          text: 'U',
          name: 'textDecoration',
          value: 'underline',
          anti: 'none',
          selected: false,
          style: {
            'text-decoration': 'underline',
          }
        }
      ],
      reports: {
        fontWeight: 'fontStyle_setting_panel,click_bold,样式设置面板_加粗',
        fontStyle: 'fontStyle_setting_panel,click_italic,样式设置面板_斜体',
        textDecoration: 'fontStyle_setting_panel,click_underline,样式设置面板_下划线'
      }
    }
  },
  watch: {
    'boxData.judgeBox': {
      handler (val) {
        if (val) {
          this.$nextTick(() => {
            this.render();
          })
        }
      }
    }
  },
  methods: {
    render () {
      const vm = this;
      vm.$refs.transparentSlider
        && vm.$refs.transparentSlider.updateValFromOutside(vm.sprite.getTransparent());

      let fontObj = this.sprite.font;
      this.options[0].selected = fontObj.fontWeight === 'bold';
      this.options[1].selected = fontObj.fontStyle === 'italic';
      this.options[2].selected = fontObj.textDecoration === 'underline';
    },
    onTransparentUpdated (val, undo) {
      this.sprite.setTransparent({
        percent: val,
        undo
      });
      if (undo) {
        this.$analysis('fontStyle_setting_panel,drag_blur,样式设置面板_透明度');
      }
    },
    selectStyle (v) {
      if (this.sprite.versionAnyway == 'Vertical' && (v.value === 'italic' || v.value === 'underline')) {
        this.$message({
          showClose: true,
          message: '你好！竖版文字不支持艺术字效果和下划线、倾斜样式，如需使用请调整样式。'
        });
        return;
      }
      this.render()
      this.updateSprite({
        [v.name]: v.selected ? '' : v.value
      }).then(() => {
        let fontObj = this.sprite.option.font;
        this.$set(v, 'selected', !v.selected);
      });

      this.$analysis(this.reports[v.name]);
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 258px;
  // min-height: 180px;
  z-index: 35;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 3px 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
    cursor: move;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }

  &__content {
    padding: 14px 0;
  }

  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#ffffff, 0.7);
  }
}

.items {
  padding-top: 25px;
}

.item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 14px;
  padding-right: 14px;
  margin-bottom: 25px;

  &__title {
    flex-shrink: 0;
    width: 56px;
    margin-right: 10px;
    text-align: left;
  }

  &__style {
    display: inline-block;
    width: 24px;
    margin-right: 26px;
    font-size: 20px;
    color: rgb(71, 66, 97);
    cursor: pointer;
    font-family: san-serif;
    text-align: left;

    &:nth-of-type(2) {
      font-family: serif;
    }

    &:last-of-type {
      margin-right: 0;
    }

    &.is-selected {
      color: #5778fb
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/popupsNew/textSetting/styleSetting.vue